import {PATH_TO_AFFILIATES} from '../constants';

function getAffiliatesImage(path: string) {
  // Remove query parameters if present (e.g., '/forms/nerdwallet?param=value' -> '/forms/nerdwallet')
  const pathname = path.split('?')[0];

  for (const affiliatePath in PATH_TO_AFFILIATES) {
    if (pathname === affiliatePath) {
      return PATH_TO_AFFILIATES[affiliatePath];
    }
  }

  return undefined;
}

export default getAffiliatesImage;
